import RestApi from './../../api/rest-api-client'
const srvcEndpoint = '/lead_vendors'
export default {
  search: async (req, opts) => RestApi.request('GET', srvcEndpoint, req, opts),
  get: async (id, req, opts) =>
    RestApi.request('GET', srvcEndpoint, id, req, opts),
  store: async (data, opts) =>
    RestApi.request('POST', srvcEndpoint, data, opts),
  update: async (id, data, opts) =>
    RestApi.request('PUT', srvcEndpoint, id, data, opts),
  delete: async (id, opts) => RestApi.request('DELETE', srvcEndpoint, id, opts),
  // Returns LeadVendors, LeadCreditPackages, AgentLedger (of auth user) for Order Leads page.
  pages: async (page, req, opts) =>
    RestApi.request('GET', srvcEndpoint, req, { endpoint: `/pages/${page}` }),
}
